import { createContext, useContext, ReactNode } from 'react';
import { useGameState } from '../hooks/useGameState';
import { GameData } from '../types/game';
import { World, Level, WorldsManifest } from '../types/world';

interface GameContextType {
  gameData: GameData | null;
  loading: boolean;
  worlds: Map<string, World>;
  getLevel: (worldId: string, levelId: string) => Level | null;
  loadWorldData: (worldId: string, manifest?: WorldsManifest) => Promise<World | null>;
  completeLevel: (worldId: string, levelId: string) => void;
  saveProof: (worldId: string, levelId: string, proof: import('../types/game').ProofRecord) => void;
  isLevelCompleted: (worldId: string, levelId: string) => boolean;
  isLevelUnlocked: (worldId: string, level: Level, levels: Level[], completedLevels: string[]) => boolean;
  isWorldUnlocked: (worldId: string, world: World) => boolean;
  isLecturer: () => boolean;
  saveGameData: (data: GameData) => void;
}

const GameContext = createContext<GameContextType | undefined>(undefined);

export function GameProvider({ children }: { children: ReactNode }) {
  const gameState = useGameState();

  return (
    <GameContext.Provider value={gameState}>
      {children}
    </GameContext.Provider>
  );
}

export function useGame() {
  const context = useContext(GameContext);
  if (context === undefined) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
}
